module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"translucency":"データ濃色","mapDisplay":"地図表示","feature-0":"河川","feature-1":"流域界","feature-2":"行政界"},"en":{"translucency":"Translucency","mapDisplay":"Map display","feature-0":"River","feature-1":"Watershed","feature-2":"Administrative District"}}')
  delete Component.options._Ctor
}
